import subscriptionErrorAlertDictionary from '@widgets/subscription-error-alert/i18n/ru/subscription-error-alert.dic.json';

export const subscriptionErrorAlert = {
  SUBSCRIPTION_ERROR_ALERT: subscriptionErrorAlertDictionary,
};

export const subscriptionErrorAlertNamespaces = ['SUBSCRIPTION_ERROR_ALERT'];
